module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOS4wNCIgaGVpZ2h0PSIyNS4yODciIHZpZXdCb3g9IjAgMCAyOS4wNCAyNS4yODciPjxwYXRoIGQ9Ik0yNi4wMTMgNS41MzNIMy44MDRhMi4yMDIgMi4yMDIgMCAwIDEgMC00LjQwNGgyMi4yMDlhMi4yMDIgMi4yMDIgMCAwIDEgMCA0LjQwNHptMCA5LjU4OEgzLjgwNGEyLjIwMiAyLjIwMiAwIDAgMSAwLTQuNDA0aDIyLjIwOWEyLjIwMiAyLjIwMiAwIDAgMSAwIDQuNDA0em0wIDkuMjEySDMuODA0YTIuMjAyIDIuMjAyIDAgMCAxIDAtNC40MDRoMjIuMjA5YTIuMjAyIDIuMjAyIDAgMCAxIDAgNC40MDR6IiBmaWxsPSIjRkZGIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/stickyMenu.svg
// module id = 119
// module chunks = 0